import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getBannerUrl } from "../api/getMessageBoard";

class BannerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { type } = this.props;
    this.props.request(type);
  }

  render = () => {
    const { data, loading, failure, render, type } = this.props;
    const banner = (data && data.data) || [];
    const banners = type === "promo" ? banner.slice(0, 3) : banner;
    return !loading && render({ banner: banners, loading, failure });
  };
}

BannerContainer.propTypes = {
  type: PropTypes.string.isRequired,
};

export default CreateContainer(getBannerUrl, BannerContainer);
